export type ProfileTheme = {
  id: 'default' | 'neon' | 'gold' | 'purple' | 'darkClub';
  name: string;
  description: string;
  heroGradient: string;
  progressGradient: string;
  glowColor: string;
  accentBadge: string;
  activeMission: string;
  surface: string;
  primaryButton: string;
  pageGlow: string;
  coinsGradient: string;
};

export const PROFILE_THEMES: Record<ProfileTheme['id'], ProfileTheme> = {
  default: {
    id: 'default',
    name: 'Default',
    description: 'Energia equilibrada com neon suave.',
    heroGradient: 'from-[#161725] via-[#0f1830] to-[#090a12]',
    progressGradient: 'from-cyan-400 via-blue-500 to-pink-500',
    glowColor: 'bg-cyan-300/20',
    accentBadge: 'bg-cyan-500/10 border-cyan-500/20 text-cyan-300',
    activeMission:
      'from-cyan-400/18 via-blue-500/14 to-pink-500/10 border-cyan-400/20 text-cyan-300',
    surface: 'bg-[#10131d]/88 border-white/8',
    primaryButton: 'from-cyan-500 to-blue-500',
    pageGlow: 'from-cyan-500/14 via-transparent to-pink-500/12',
    coinsGradient: 'from-yellow-400/16 via-yellow-500/8 to-[#16151f]',
  },
  neon: {
    id: 'neon',
    name: 'Neon',
    description: 'Visual vibrante e futurista.',
    heroGradient: 'from-[#111320] via-[#22113b] to-[#090a12]',
    progressGradient: 'from-fuchsia-400 via-cyan-400 to-blue-500',
    glowColor: 'bg-fuchsia-300/20',
    accentBadge: 'bg-fuchsia-500/10 border-fuchsia-500/20 text-fuchsia-300',
    activeMission:
      'from-fuchsia-400/18 via-cyan-400/14 to-blue-500/10 border-fuchsia-400/20 text-fuchsia-300',
    surface: 'bg-[#140f22]/88 border-fuchsia-500/8',
    primaryButton: 'from-fuchsia-500 to-cyan-500',
    pageGlow: 'from-fuchsia-500/14 via-transparent to-cyan-500/12',
    coinsGradient: 'from-fuchsia-400/16 via-cyan-400/8 to-[#17111d]',
  },
  gold: {
    id: 'gold',
    name: 'Gold',
    description: 'Luxo competitivo com brilho dourado.',
    heroGradient: 'from-[#20170d] via-[#33210f] to-[#0b0a09]',
    progressGradient: 'from-yellow-300 via-amber-400 to-orange-500',
    glowColor: 'bg-yellow-300/20',
    accentBadge: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-300',
    activeMission:
      'from-yellow-300/16 via-amber-400/14 to-orange-500/10 border-yellow-300/20 text-yellow-200',
    surface: 'bg-[#18120d]/88 border-yellow-500/8',
    primaryButton: 'from-yellow-400 to-amber-500',
    pageGlow: 'from-yellow-500/14 via-transparent to-orange-500/12',
    coinsGradient: 'from-yellow-300/20 via-amber-400/10 to-[#1a1510]',
  },
  purple: {
    id: 'purple',
    name: 'Purple',
    description: 'Aura cósmica com foco em progressão.',
    heroGradient: 'from-[#161126] via-[#261642] to-[#090a12]',
    progressGradient: 'from-violet-400 via-fuchsia-500 to-pink-500',
    glowColor: 'bg-violet-300/20',
    accentBadge: 'bg-violet-500/10 border-violet-500/20 text-violet-300',
    activeMission:
      'from-violet-400/18 via-fuchsia-500/14 to-pink-500/10 border-violet-400/20 text-violet-200',
    surface: 'bg-[#151025]/88 border-violet-500/8',
    primaryButton: 'from-violet-500 to-fuchsia-500',
    pageGlow: 'from-violet-500/14 via-transparent to-pink-500/12',
    coinsGradient: 'from-violet-400/16 via-fuchsia-500/8 to-[#18111d]',
  },
  darkClub: {
    id: 'darkClub',
    name: 'Dark Club',
    description: 'Club noturno com contraste forte.',
    heroGradient: 'from-[#0b0d12] via-[#131722] to-[#07080c]',
    progressGradient: 'from-emerald-400 via-cyan-500 to-blue-500',
    glowColor: 'bg-emerald-300/18',
    accentBadge: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-300',
    activeMission:
      'from-emerald-400/16 via-cyan-500/12 to-blue-500/10 border-emerald-400/20 text-emerald-200',
    surface: 'bg-[#0f141c]/88 border-emerald-500/8',
    primaryButton: 'from-emerald-500 to-cyan-500',
    pageGlow: 'from-emerald-500/12 via-transparent to-cyan-500/12',
    coinsGradient: 'from-emerald-400/12 via-cyan-500/8 to-[#10141a]',
  },
};

export const PROFILE_THEME_LIST = Object.values(PROFILE_THEMES);
